import { render, staticRenderFns } from "./AssignTeamsForm.vue?vue&type=template&id=184f74ed&scoped=true&"
import script from "./AssignTeamsForm.vue?vue&type=script&lang=js&"
export * from "./AssignTeamsForm.vue?vue&type=script&lang=js&"
import style0 from "./AssignTeamsForm.vue?vue&type=style&index=0&id=184f74ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f74ed",
  null
  
)

export default component.exports